import BlogAllPage from 'views/blog/all'
import { getServerSideProps } from 'views/blog/all/server'

export default BlogAllPage
export { getServerSideProps }
